import { withInstall } from '@xzx-design/utils'
import _Sticky from './src/sticky.vue'

export const Sticky = withInstall(_Sticky)
export default Sticky

export * from './src/sticky'
